import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import './WinePreviewModal.css';
var WinePreviewModal = function (_a) {
    var wine = _a.wine, isOpen = _a.isOpen, onClose = _a.onClose, language = _a.language;
    var modalRef = useRef(null);
    useEffect(function () {
        if (isOpen && modalRef.current) {
            modalRef.current.focus();
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'unset';
        }
        return function () {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);
    useEffect(function () {
        var handleEscape = function (e) {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
        }
        return function () {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);
    if (!isOpen || !wine)
        return null;
    return (_jsx("div", { className: "wine-preview-overlay", onClick: onClose, children: _jsxs("div", { className: "wine-preview-modal", onClick: function (e) { return e.stopPropagation(); }, ref: modalRef, tabIndex: -1, children: [_jsx("button", { className: "wine-preview-close", onClick: onClose, "aria-label": "Close", children: "\u00D7" }), _jsx("div", { className: "wine-preview-frame", children: _jsx("img", { src: wine.imageUrl, alt: language === 'bg' ? wine.nameBg : wine.name, className: "wine-preview-image", onError: function (e) {
                            var target = e.target;
                            target.src = '/api/products/default-image';
                        } }) })] }) }));
};
export default WinePreviewModal;
